import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import Price from "../views/Price.vue"
import News from "../views/News.vue"
import NewsDetails from "../views/NewsDetails.vue"
import Ximi from "../views/Ximi.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/price",
    name: "Price",
    component: Price
  },
  {
    path: "/news",
    name: "News",
    component: News
  },
  {
    path: "/detail",
    name: "NewsDetail",
    component: NewsDetails
  },
  {
    path: "/ximi",
    name: "Ximi",
    component: Ximi
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
